const callbacks = {
  country(textEl, listItemButtonEl) {
    if (textEl)  {
      textEl.setAttribute('xlink:href', listItemButtonEl.dataset.svg)
    }
    fetch('/index.php?route=common/language/change&id=' + listItemButtonEl.dataset.languageId)
      .then(() => {
        location.reload()
      })
  },
  default(textEl, listItemButtonEl) {
    textEl.textContent = listItemButtonEl.textContent
  },
  empty() {},
}

export function getContentCallback(popupListEl) {
  if (Object.hasOwnProperty.call(callbacks, popupListEl.dataset.callback)) {
    return callbacks[popupListEl.dataset.callback]
  }

  return callbacks.default
}
